/* eslint-disable jsdoc/require-jsdoc */
import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';

interface DashboardWidgetContainerProps {
  name: 'map' | 'histogram';
  title: string;
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<'map' | 'histogram'>>;
  extendedLabel: string;
  children?: React.ReactNode;
}

export default function DashboardWidgetContainer({
  name,
  title,
  expanded,
  setExpanded,
  extendedLabel,
  children
}: DashboardWidgetContainerProps): ReactElement {
  const navigate = useNavigate();

  const handleToggle = (): void => {
    const targetOnExpand = name;
    const targetOnCollapse = name === 'map' ? 'histogram' : 'map';
    setExpanded(expanded ? targetOnCollapse : targetOnExpand);
  };

  return (
    <div
      className={`flex flex-col bg-background-700 col-span-1 p-4 h-[32rem] md:h-auto flex-1 ${
        expanded ? 'md:col-span-3' : 'md:col-span-2'
      }`}
    >
      <div className="flex w-full">
        <Header
          sectionName={title}
          showIcon
          actionButton={() => navigate('/settings/device-setup?tab=groups')}
          actionButtonText="Settings"
        >
          <div>
            <div className="flex items-center gap-2">
              <span className="font-regular text-gray-400 cursor-default">{extendedLabel}</span>
              <button
                type="button"
                onClick={handleToggle}
                className="material-icons text-2xl text-gray-300"
                style={{ transform: 'rotate(45deg)' }}
              >
                {expanded ? 'unfold_less' : 'unfold_more'}
              </button>
            </div>
          </div>
        </Header>
      </div>
      <div className="flex flex-1 w-full h-full mt-2">{children}</div>
    </div>
  );
}
